(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/lotto-part-result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/lotto-part-result.js');

'use strict';

svs.numbergames.results.models.LottoPartResult = Backbone.Model.extend({
  defaults: {
    productId: 'LOTTO',
    type: undefined,
    numbers: [],
    numbersExtra: [],
    payout: undefined
  },
  parse(attrs) {
    const _attrs$correctRow = attrs.correctRow,
      numbers = _attrs$correctRow.numbers,
      numbersExtra = _attrs$correctRow.numbersExtra;
    return {
      numbers,
      numbersExtra,
      type: attrs.type,
      payout: new svs.numbergames.results.models.PayoutTable(attrs.payout)
    };
  }
});

 })(window);